import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
    color:  ${nuDSColor('primary')}
  }
`;

StyledLink.displayName = 'StyledLink';
